import { GameManager } from "./../../GameManager";
import { GameConstants } from "./../../GameConstants";
import { Button } from "../../utils/Utils";
import { BoardScene } from "./BoardScene";
import { StyleButton } from "./StyleButton";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class PauseLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.visible = false;

        let bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000, .75);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerdown", () => { 
            //
        });
        this.add(bck);

        let bck2 = new Phaser.GameObjects.Graphics(this.scene);
        bck2.fillStyle(0x000000, .7);
        bck2.fillRect(0, 260, GameConstants.GAME_WIDTH, 260);
        this.add(bck2);

        let pauseText = new Phaser.GameObjects.Text(this.scene, 30, 10, GameVars.gameText.GAME[3], {fontFamily: "HelveticaNeue", fontSize: "60px", color: "#FFFFFF"});
        this.add(pauseText);

        let styleButton = new StyleButton(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 - 60);
        this.add(styleButton);

        let resumeBtn = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 85, GameConstants.GAME_HEIGHT / 2 + 130, "texture_atlas_language", "btn_resume", "btn_resume_hover");
        resumeBtn.onUp(this.onResumeDown, this);
        this.add(resumeBtn);

        let quitBtn = new Button(this.scene, GameConstants.GAME_WIDTH / 2 + 85, GameConstants.GAME_HEIGHT / 2 + 130, "texture_atlas_language", "btn_quit", "btn_quit_hover");
        quitBtn.onUp(this.onQuitDown, this);
        this.add(quitBtn);
    }

    private onResumeDown(): void {

        AudioManager.playSound("click");

        BoardScene.currentInstance.hidePauseLayer();
    }

    private onQuitDown(): void {

        AudioManager.playSound("click");

        GameManager.enterSplashScene();
    }
}
